// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"137":"ad0581e1","229":"b88bb34c","550":"b88bb34c","800":"ad0581e1"}[chunkId] + ".chunk.css";
};